import { ILogsUserData } from '@pharmaplan/common';

import { renderScreen } from '../../../actions/drawerActions';
import { ScreenTypes } from '../../../helpers/Constants';
import { useAppDispatch } from '../../useAppDispatch';
import useDrawer from '../../useDrawer';

// OPENS THE USERS COLLAPSED BEHIND A COUNT IN THE ACTIVITY LOGS TABLE
const useActivityLogUsers = () => {
  const dispatch = useAppDispatch();
  const { openDrawer } = useDrawer();

  const showUsersList = (users: Array<ILogsUserData>) =>
    () => {
      openDrawer();
      dispatch(
        renderScreen({
          screenNumber: 1,
          screenType: ScreenTypes.activityLogUsers,
          extraParameters: { users },
        }),
      );
    };

  return { showUsersList };
};

export default useActivityLogUsers;
